import loadable from '@loadable/component';

export { SearchBarProvider, useSearchBarContext } from './SearchBarContext';

export const LoadableSearchBar = loadable(
  () =>
    import(/* webpackChunkName: "SearchBar" */ './components/SearchBarLazy'),
);
